import { Component, Input, OnInit } from '@angular/core';
import { AlertController, NavController, ModalController, LoadingController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { AlertService } from 'src/app/services/alert.service';
import { AquabotService } from 'src/app/services/aquabot.service';
import { AuthService } from 'src/app/services/auth.service';
import { EscanerService } from 'src/app/services/escaner.service';
import { RedatwaterService } from 'src/app/services/redatwater.service';
import { TextSpeechService } from 'src/app/services/text-speech.service';
import { TranslateConfigService } from 'src/app/services/translate-config.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { AppComollegarComponent } from '../app-comollegar/app-comollegar.component';
import { Header } from 'src/app/interfaces/book.interface';

@Component({
  selector: 'app-app-cajeros-agua',
  templateUrl: './app-cajeros-agua.component.html',
  styleUrls: ['./app-cajeros-agua.component.scss'],
})
export class AppCajerosAguaComponent implements OnInit {

  @Input() channelApp: any;

  //private subscription: Subscription = new Subscription();

  authDispositivo: any = null;
  channelSistema: any = null;

  idiomaSeleccionado: string = null;
  selectedLanguage: string;
  itemsIdiomaApp: any = [];
  itemsIdioma: any = [];
  idiomaPagina = 'APP_CAJEROSAGUA';

  aquaBot: any = {
    guia_referencia: '',
    msg: '',
    estado: ''
  };

  header: Header = {
    nivel: 2,
    pagina: ''
  }

  precioActualLitroSistema = 0;
  coberturaCajerosATWATER: boolean = false;
  coberturaCajeros: any[] = [];
  cajerosCercanos: Array<any> = Array();
  totalCajerosCerca:number = 0;

  anunciosPubliAqua: Array<any> = Array();
  anunciosLista: any = [];
  slideAnuncios: any[] = [];
  totalAnuncios = 0;

  constructor(
    private translateConfigService: TranslateConfigService,
    private ventanaAlerta: AlertService,
    private redatwater: RedatwaterService,
    private auth: AuthService,
    private navCtrl: NavController,
    private modalController: ModalController,
    private escaner: EscanerService,
    private loadingCtrl: LoadingController,
    private aquabot: AquabotService,
    private textSpeech: TextSpeechService
  ) {
    console.log('App -> Cajeros de Agua cerca!');
  }

  ngOnInit() {

    console.log('Seguimiento -> Data channel: ', this.channelApp);
    this.channelSistema = this.channelApp[0].channel_sistema;

    if (this.channelSistema?.contacto.litro_agua) {
      this.precioActualLitroSistema = this.channelSistema.contacto.litro_agua.data;
      console.log('Seguimiento -> Precio de litro de agua: ', this.precioActualLitroSistema);
    }

    this.auth.loadAuthTokenDispositivo().then(async (getDispositivo: any) => {
      console.log('Dispositivo Auth ->', getDispositivo);
      if (getDispositivo) {
        this.authDispositivo = getDispositivo;
        console.log('Seguimiento -> Auth dispositivo: ', this.authDispositivo);
        this.translateConfigService.initAppIdioma().then((dataIdioma: any) => {
          this.translateConfigService.itemsIdiomaPagina(this.idiomaPagina).then((dataPagina: any) => {
            this.itemsIdiomaApp = this.translateConfigService.getItemsIdiomaApp();
            this.itemsIdioma = this.translateConfigService.getItemsIdioma();

            if (this.itemsIdiomaApp && this.itemsIdioma) {
              //console.log('Parametros de idioma App -> ', this.itemsIdiomaApp);
              //console.log('Parametros de idioma -> ', this.itemsIdioma);
              //console.log('Test 1 -> ', this.itemsIdiomaApp.app_loading);

              this.aquaBot = this.aquabot.appMsgAquaBot({
                msg: this.itemsIdiomaApp.aquabot_msg_cajeros,
                estado: 'text-primary'
              });

              if (this.channelApp[0].lista_cobertura_cajeros_atwater) { // COBERTURA CAJEROS DE AGUA
                console.log('Seguimiento -> Cobertura de cajeros de agua: ', this.channelApp[0].lista_cobertura_cajeros_atwater);
                this.coberturaCajerosATWATER = true;
                this.coberturaCajeros = this.channelApp[0].lista_cobertura_cajeros_atwater;
                this.procesarCajerosCerca();
                
              }

              this.anuncios();

            } else {
              this.translateConfigService.resetIdioma(this.idiomaPagina);
            }
          }).catch((err: any) => {
            console.log('Seguimiento de errores -> ', err);
          });
        }).catch((err: any) => {
          console.log('Seguimiento de errores -> ', err);
        });
      } else {
        this.navCtrl?.navigateRoot(['/app-salir']);
      }
    });

  }

  seleccionarIdioma(idioma) {
    if (idioma) {
      //console.log('Seleccionar idioma -> ', idioma);
      this.selectedLanguage = idioma;
      //console.log('Idioma seleccionado: ' + this.selectedLanguage);
      this.languageChanged(this.selectedLanguage);
      this.idiomaSeleccionado = idioma;

      this.translateConfigService.initAppIdioma().then((dataIdioma: any) => {
        this.translateConfigService.itemsIdiomaPagina(this.idiomaPagina).then((dataPagina: any) => {
          this.itemsIdiomaApp = this.translateConfigService.getItemsIdiomaApp();
          this.itemsIdioma = this.translateConfigService.getItemsIdioma();
          this.translateConfigService.getItemsIdioma();
          if (this.itemsIdiomaApp && this.itemsIdioma) {
            //console.log('Parametros de idioma App -> ', this.itemsIdiomaApp);
            //console.log('Parametros de idioma -> ', this.itemsIdioma);
            //console.log('Test 2 -> ', this.itemsIdiomaApp.app_loading);

            this.textSpeech.hablar(this.itemsIdioma.hablar_app_intrucciones);
          } else {
            this.translateConfigService.resetIdioma(this.idiomaPagina);
          }
        }).catch((err: any) => {
          console.log('Seguimiento de errores -> ', err);
        });
      }).catch((err: any) => {
        console.log('Seguimiento de errores -> ', err);
      });
    }
  }

  languageChanged(idioma: string) {
    this.translateConfigService.setLanguage(idioma);
  }

  ngOnDestroy() {

  }


  async anuncios() {

    const loading = await this.loadingCtrl.create({
      message: this.itemsIdiomaApp.loading,
      spinner: 'crescent',
      showBackdrop: true
    });
    loading.present();

    this.redatwater.consultarAnunciosFull().then((getData: any) => {

      console.log('Seguimiento Data -> Parametros Anuncios: ', getData);

      if (getData) {

        if (getData?.lista_general) {
          this.anunciosLista = getData.lista_general;
          //console.log('Seguimiento -> Anuncios Sistema: ', getData.lista_general);
          this.procesarAnuncio();
          loading.dismiss();

        } else {
          //console.log('Seguimiento de errores -> Data, Anuncios en dispositivo: ', getData);
          this.ventanaAlerta.msgAppCenter(this.itemsIdiomaApp.app_titulo_alertas, this.itemsIdioma.alerta_anuncio_internet);
          loading.dismiss();
        }

      } else {
        //console.log('Seguimiento de errores -> Parametros Data, Anuncios en dispositivo: ', getData);
        this.ventanaAlerta.msgAppCenter(this.itemsIdiomaApp.app_titulo_alertas, this.itemsIdioma.alerta_anuncio_informacion_valida);
        loading.dismiss();
      }

    }).catch((err: any) => {
      //console.log('Seguimiento de errores -> Anuncios en dispositivo: ', err);
      this.ventanaAlerta.msgAppCenter(this.itemsIdiomaApp.app_titulo_alertas, this.itemsIdioma.alerta_anuncio_error);
      loading.dismiss();
    });
  }

  async procesarAnuncio() {
    if (this.anunciosLista) {

      let anuncios: Array<any> = Array();

      this.anunciosLista.forEach(data => {
        if (data.id) {
          if (this.verificarAnuncio(data)) {

            const item = {
              id: data.id,
              global: data.global,
              titulo: data.titulo,
              link: data.link,
              file: data.file,
              fecha_publicacion: data.fecha_publicacion,
              fecha_finalizacion: data.fecha_finalizacion,
              estado: data.estado,
              empresa_id: data.empresa_id,
              descripcion: data.descripcion,
              created_at: data.created_at,
              updated_at: data.updated_at,
              categoria: data.categoria,
              categoria_id: data.categoria_id,
              views: data.views,
            };

            this.anunciosPubliAqua.push(item);
            anuncios.push(item);

            console.log('Seguimiento -> Anuncio procesado...');



          } else {
            console.log('Seguimiento -> Anuncio denegado...');
          }
        } else {
          console.log('Seguimiento de errores -> Parametros de Data: ', data);
        }

      });

      this.slideAnuncios = anuncios;
      //console.log('Seguimiento -> Anuncios: ', this.anunciosPubliAqua);
      //console.log('Slide anuncios: ', this.slideAnuncios);
      this.totalAnuncios = this.anunciosPubliAqua.length;

    }
  }

  async verificarAnuncio(anuncio: any) {
    if (anuncio) {
      //console.log('Seguimiento -> Verificar: ', anuncio);
      return true;
    } else {
      //console.log('Seguimiento de errores -> Verificar anuncio: ', anuncio);
      return false;
    }
  }

  async instruccionesApp(texto: String) {
    this.ventanaAlerta.msgAppCenter(this.itemsIdiomaApp.app_titulo_alertas, ("<b><u>" + this.itemsIdioma.app_intrucciones + ":</u></b> <span class='text-success'>" + texto + "</span>"));
  }


  async cerrarVentana() {
    this.closeModal();
  }

  closeModal() {
    console.log('Cerrar ventana!');
    this.modalController.dismiss({ cajerosAgua: this.cajerosCercanos }).catch((err:any) => {
      console.log('Seguimiento de errores -> ', err);
    });
  }

  async procesarCajerosCerca() {
    console.log('Seguimiento -> Cajeros cercanos');
    if (this.coberturaCajeros) {
      let dataCajero: any = null;
      let parametrosCajeros: any = null;
      this.coberturaCajeros.forEach(getCajero => {
        if (getCajero?.id) {

          this.redatwater.getDataSistema(getCajero.id).then((getData: any) => {
            if (getData) {
              
              console.log('Seguimiento -> Datos de sistema: ', getData);

              if (getData?.channel_app[0].channel_sistema) {
                dataCajero = getData?.channel_app[0].channel_sistema;
                const img = 'assets/img/sistemas/' + dataCajero.modelo_id + '.png';
                parametrosCajeros = {
                  data: dataCajero,
                  img: img
                }
                this.cajerosCercanos.push(parametrosCajeros);
              }

              this.totalCajerosCerca = this.cajerosCercanos.length;

            } else {
              console.log('Seguimiento de errores ->  ', getData);
            }
          });

        }
        dataCajero = null;
        parametrosCajeros = null;
      });

    } else {
      console.log('Seguimiento de errores -> ', this.coberturaCajeros);
    }
  }

  async comoLlegar(cajero: any) {
    if (cajero.data) {

      console.log('Seguimiento -> Consultar ¿Como llegar a sistema? ');
      const channelApp = this.channelApp;
      const sistemaSeleccionado = cajero;

      const modalAdd = await this.modalController.create({
        component: AppComollegarComponent,
        mode: 'ios',
        swipeToClose: true,
        componentProps: { channelApp, sistemaSeleccionado }
      });
      await modalAdd.present();
      const { data } = await modalAdd.onWillDismiss();
      if (data) {
        console.log('Seguimiento -> Data de ¿Como llegar?: ', data);

      }

    } else {
      console.log('Seguimiento de errores -> ', cajero);
    }
  }

  async generarCodigo(cajero: any) {
    if (cajero.data) {
      console.log('Seguimiento -> Generar QR de cajero');
      let codigoArray = {
        token: this.escaner.getTokenApp(),
        categoria: 'sistema_key',
        sistema_key: cajero.data.private_key
      };
      this.escaner.generarQr(codigoArray).then(() => { }).catch((err) => { console.log('Error: ', err); });
    } else {
      console.log('Seguimiento de errores -> ', cajero);
    }
  }
}
